// Component for uploading a new clothing item
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UploadCloth = () => {
  const [formData, setFormData] = useState({
    cloth_name: '',
    category: '',
    color: '',
    size: '',
    season: '',
    brand: '',
    material: '',
    pattern: '',
    sleeveLength: ''
  });
  const [file, setFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file)); // Preview the image
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }
    if (file) {
      data.append('image', file);
    }

    const token = localStorage.getItem('token');
    console.log("Token:", token); // Log the token for debugging
    const config = {
      headers: { Authorization: `Bearer ${token}` }
  };

  try {
      const response = await axios.post('http://localhost:3000/api/clothes', data, config);
      console.log("Response:", response.data); // Log the response for debugging
      navigate('/clothes'); // Redirect to Clothes page
    } catch (error) {
      console.error('Error uploading cloth:', error);
      alert('Error uploading cloth. Please try again.');
    }
  };

  return (
    <div className="upload-form-container">
      <h1 className="upload-title"><strong>𝒰𝓅𝓁𝑜𝒶𝒹 𝒞𝓁𝑜𝓉𝒽𝑒𝓈</strong></h1>
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label htmlFor="cloth_name"><strong>Cloth Name</strong>*:</label>
          <input type="text" name="cloth_name" id="cloth_name" value={formData.cloth_name} onChange={handleChange} placeholder="Enter cloth name" required/>
        </div>
        <div className="form-group">
          <label htmlFor="category"><strong>Category\-ies</strong>*:</label>
          <input type="text" name="category" id="category" value={formData.category} onChange={handleChange} placeholder="e.g. T-Shirts, Pants..." required/>
        </div>
        <div className="form-group">
          <label htmlFor="color"><strong>Color\-s</strong>*:</label>
          <input type="text" name="color" id="color" value={formData.color} onChange={handleChange} placeholder="At least one color" required/>
        </div>
        <div className="form-group">
          <label htmlFor="size"><strong>Size</strong>:</label>
          <input type="text" name="size" id="size" value={formData.size} onChange={handleChange} placeholder="e.g. L or Large"/>
        </div>
        <div className="form-group">
          <label htmlFor="season"><strong>Season\-s</strong>*:</label>
          <input type="text" name="season" id="season" value={formData.season} onChange={handleChange} placeholder="Winter, Summer, Autumn, Spring" required/>
        </div>
        <div className="form-group">
          <label htmlFor="brand"><strong>Brand</strong>:</label>
          <input type="text" name="brand" id="brand" value={formData.brand} onChange={handleChange} placeholder="e.g. Nike, Adidas"/>
        </div>
        <div className="form-group">
          <label htmlFor="material"><strong>Material</strong>:</label>
          <input type="text" name="material" id="material" value={formData.material} onChange={handleChange} placeholder="e.g. Cotton, Polyester"/>
        </div>
        <div className="form-group">
          <label htmlFor="pattern"><strong>Pattern</strong>:</label>
          <input type="text" name="pattern" id="pattern" value={formData.pattern} onChange={handleChange} placeholder="e.g. Curduroy"/>
        </div>
        <div className="form-group">
          <label htmlFor="sleeveLength"><strong>Sleeve Length</strong>:</label>
          <input type="text" name="sleeveLength" id="sleeveLength" value={formData.sleeveLength} onChange={handleChange} placeholder="e.g. Long/short sleeve"/>
        </div>
        <div className="form-group">
          <label htmlFor="image"><strong>Image</strong>*:</label>
          <input type="file" id="image" onChange={handleFileChange} placeholder="Please upload a clear image of the cloth" required/>
        </div>
        {previewImage && (
          <div className="image-preview">
            <img src={previewImage} alt="Preview" width="300px" />
          </div>
        )}
        <button type="submit" className="upload-btn"><i className="fa-solid fa-plus"></i> <strong>𝒰𝓅𝓁𝑜𝒶𝒹</strong></button>
      </form>
    </div>
  );
};

export default UploadCloth;